import { render, staticRenderFns } from "./prestoreAccount2.vue?vue&type=template&id=1fd3dc3c&scoped=true"
import script from "./prestoreAccount2.vue?vue&type=script&lang=js"
export * from "./prestoreAccount2.vue?vue&type=script&lang=js"
import style0 from "./prestoreAccount2.vue?vue&type=style&index=0&id=1fd3dc3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd3dc3c",
  null
  
)

export default component.exports